type PerfilComCliente = {
  name?: string | null;
  customerName?: string | null;
};

const normalizar = (valor: string) => valor.trim().toLowerCase();

/**
 * Nome do cliente dono do perfil. A lista mostrava só a ficha do Google, mas
 * quem vai cobrar o acesso de volta precisa saber com quem falar. Quando o
 * cliente foi cadastrado com o mesmo nome da ficha, o texto é omitido — repetir
 * a mesma palavra na linha não informa nada.
 */
export const descricaoDoCliente = ({ name, customerName }: PerfilComCliente): string | null => {
  const cliente = (customerName ?? "").trim();
  if (!cliente) return null;
  if (normalizar(cliente) === normalizar(name ?? "")) return null;
  return cliente;
};

const SITUACOES: Record<string, string> = {
  CANCELED: "cliente cancelado",
  INACTIVE: "cliente inativo",
  WAITING_FIRST_PAYMENT: "aguardando 1º pagamento",
};

/** Aviso quando o cliente não está ativo: cobrar acesso de quem saiu é perda de tempo. */
export const situacaoDoCliente = (status?: string | null): string | null => {
  if (!status || status === "ACTIVE") return null;
  return SITUACOES[status] ?? status;
};
